import styled from 'styled-components';
import { Row, Col, Radio } from 'antd';
import { DEFAULT_RISK_RPN_COLOR } from '@/utils/constants';

interface TabProps {
	$isSelected: boolean;
}

export const SubCategoryContainer = styled(Row)`
	border-radius: 18px;
	padding: 15px 20px;
	background-color: #f8f8f8;
`;

export const Item = styled(Row)`
	height: 100%;
	text-align: center;
	padding: 30px 42px;
	border-radius: 18px;
	border: 2px solid #d9d9d9;
	background-color: #ffffff;
`;

export const RadioGroup = styled(Radio.Group)`
	width: 100%;
	.ant-radio-button-wrapper {
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100%;
		padding: 30px 16px;
		text-align: center !important;
		border-radius: 18px !important;
		color: #262626 !important;
		border: 2px solid #d9d9d9;
		background-color: #ffffff;
	}
	.ant-radio-button-checked {
		background-color: #eaeefd;
		border-radius: 16px !important;
	}
	.ant-radio-button-wrapper {
		line-height: 24px !important;
	}
`;

export const CustomTabs = styled(Row)`
	background-color: #eaeefd;
	border-radius: 18px 18px 0px 0px;
`;

export const Tab = styled(Col)<TabProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 12px 0;
	font-size: 1.2rem;
	font-weight: 600;
	border-radius: 18px 18px 0px 0px;
	color: ${({ $isSelected }) => ($isSelected ? '#FFFFFF' : DEFAULT_RISK_RPN_COLOR)};
	background-color: ${({ $isSelected }) => ($isSelected ? DEFAULT_RISK_RPN_COLOR : 'transparent')};
	box-shadow: ${({ $isSelected }) => ($isSelected ? '2px 1px 5px 0px #0000001a' : 'none')};
	span {
		width: 100%;
		text-align: center;
	}
	&:hover {
		cursor: pointer;
	}
`;
